import React from 'react';
import PropTypes from 'prop-types';

import { strings } from './../../../localization';
import Switch from './../../../components/common/Switch';
import ProgressOverlay from './../../../components/common/ProgressOverlay';
import { ModalContainer } from './../../../components/common/Modal2';

import { UPDATE_SETTINGS_TIMEOUT } from './GlobalSettings';

const DAILY_REPORTS_MAX_RECIPIENTS = 10;

export default class DailyReports extends React.PureComponent {

    static propTypes = {
        user: PropTypes.object.isRequired, // for default email, if daily report values are not yet set in the API (the values will be null if defaults required)
 
        initiateAccountDailyFleetReports: PropTypes.func.isRequired,
 
        accountDailyFleetReportAvailabilityPending: PropTypes.bool.isRequired,
        accountDailyFleetReportAvailabilityEnabled: PropTypes.bool,
        accountDailyFleetReportAvailabilityErrorMessage: PropTypes.string,
        applyAccountDailyFleetReportAvailability: PropTypes.func.isRequired,
        timeoutAccountDailyFleetReportAvailability: PropTypes.func.isRequired,

        accountDailyFleetReportTimezonePending: PropTypes.bool.isRequired,
        accountDailyFleetReportTimezone: PropTypes.string,
        accountDailyFleetReportTimezoneErrorMessage: PropTypes.string,
        applyAccountDailyFleetReportTimezone: PropTypes.func.isRequired,
        timeoutAccountDailyFleetReportTimezone: PropTypes.func.isRequired,

        accountDailyFleetReportEmailsPending: PropTypes.bool.isRequired,
        accountDailyFleetReportEmails: PropTypes.array,
        accountDailyFleetReportEmailsErrorMessage: PropTypes.string,
        applyAccountDailyFleetReportEmails: PropTypes.func.isRequired,
        timeoutAccountDailyFleetReportEmails: PropTypes.func.isRequired,

        showConfirmationDialog: PropTypes.func.isRequired,
        dismissConfirmationDialog: PropTypes.func.isRequired,

        expandOrCollapseStateForUIReferences: PropTypes.func.isRequired,
        reportsExpandReference: PropTypes.string.isRequired,
        reportsExpandReferenceIsExpanded: PropTypes.bool.isRequired
    }

    constructor(props) {

        super(props);

        this.applyAccountDailyFleetReportAvailabilityTimeoutId = undefined;
        this.applyAccountDailyFleetReportTimezoneTimeoutId = undefined;
        this.applyAccountDailyFleetReportEmailsTimeoutId = undefined;

    }

    expandOrCollapseSectionsAndSubsections = (isExpanded) => {
        this.props.expandOrCollapseStateForUIReferences(isExpanded,[
            this.props.reportsExpandReference
        ]);
    }

    render() {

        const configuredTimezone = this.props.accountDailyFleetReportTimezone;
        const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "America/New_York"; // if current timezon unavailable, fall back to New York (arbitrary) https://en.wikipedia.org/wiki/List_of_tz_database_time_zones

        let accountDailyFleetReportAvailabilityEnabled = this.props.accountDailyFleetReportAvailabilityEnabled; // if not set yet, the props value will be null, which is a flag to include defaults for timezone and emails list when user first enables
        let accountDailyFleetReportTimezone = configuredTimezone || currentTimezone; // if not set yet, the props value will be null, which is a flag to initialize using the current timezone
        let accountDailyFleetReportEmails = this.props.accountDailyFleetReportEmails || [this.props.user.email]; // if not set yet, the props value will be null, which is a flag to initialize using the current user's email

        return (
            <div id="component_document_id_daily_reports">
                <h3>
                    <button
                        className={this.props.reportsExpandReferenceIsExpanded ? "settings-disclosure-wrapper" : "settings-disclosure-wrapper collapsed"}
                        onClick={() => {
                            this.expandOrCollapseSectionsAndSubsections(!this.props.reportsExpandReferenceIsExpanded)}
                        }>
                        {strings.settings_global_daily_reports_header}
                        <i className="material-icons disclosure">keyboard_arrow_up</i>
                    </button>
                </h3>
                <div>{strings.settings_global_daily_reports_description}</div>
                <div className='setting-group-horiz'>
                    <div className='setting-group switch-group'>
                        <div>
                            <Switch
                                onChange={() => {

                                    if (accountDailyFleetReportAvailabilityEnabled === null) { // ASSUMPTION: this setting is being enabled for the first time

                                        const dailyFleetReportsSettings = {
                                            enabled: !accountDailyFleetReportAvailabilityEnabled,
                                            timezone: accountDailyFleetReportTimezone,
                                            emails: accountDailyFleetReportEmails
                                        }

                                        const oldDailyFleetReportsSettings = {
                                            enabled: this.props.accountDailyFleetReportAvailabilityEnabled,
                                            timezone: this.props.accountDailyFleetReportTimezone,
                                            emails: this.props.accountDailyFleetReportEmails
                                        }

                                        clearTimeout(this.applyAccountDailyFleetReportAvailabilityTimeoutId);

                                        this.applyAccountDailyFleetReportAvailabilityTimeoutId = setTimeout(() => {this.props.timeoutAccountDailyFleetReportAvailability(oldDailyFleetReportsSettings.enabled)}, UPDATE_SETTINGS_TIMEOUT);
                                        this.applyAccountDailyFleetReportTimezoneTimeoutId = setTimeout(() => {this.props.timeoutAccountDailyFleetReportTimezone(oldDailyFleetReportsSettings.timezone)}, UPDATE_SETTINGS_TIMEOUT);
                                        this.applyAccountDailyFleetReportEmailsTimeoutId = setTimeout(() => {this.props.timeoutAccountDailyFleetReportEmails(oldDailyFleetReportsSettings.emails)}, UPDATE_SETTINGS_TIMEOUT);

                                        this.props.initiateAccountDailyFleetReports(dailyFleetReportsSettings)
                                        .then(
                                            () => {
                                                clearTimeout(this.applyAccountDailyFleetReportAvailabilityTimeoutId);
                                                clearTimeout(this.applyAccountDailyFleetReportTimezoneTimeoutId);
                                                clearTimeout(this.applyAccountDailyFleetReportEmailsTimeoutId);
                                            },
                                            () => {
                                                clearTimeout(this.applyAccountDailyFleetReportAvailabilityTimeoutId);
                                                clearTimeout(this.applyAccountDailyFleetReportTimezoneTimeoutId);
                                                clearTimeout(this.applyAccountDailyFleetReportEmailsTimeoutId);
                                            }
                                        );

                                    } else {
                                        clearTimeout(this.applyAccountDailyFleetReportAvailabilityTimeoutId);
                                        this.applyAccountDailyFleetReportAvailabilityTimeoutId = setTimeout(() => {this.props.timeoutAccountDailyFleetReportAvailability(accountDailyFleetReportAvailabilityEnabled)}, UPDATE_SETTINGS_TIMEOUT);
    
                                        this.props.applyAccountDailyFleetReportAvailability(!accountDailyFleetReportAvailabilityEnabled)
                                        .then(
                                            () => {clearTimeout(this.applyAccountDailyFleetReportAvailabilityTimeoutId)},
                                            () => {clearTimeout(this.applyAccountDailyFleetReportAvailabilityTimeoutId)}
                                        );
                                    }
                                }}
                                checked={accountDailyFleetReportAvailabilityEnabled || false}
                                disabled={this.props.accountDailyFleetReportAvailabilityPending}
                                smallFormat={true}
                            />
                            <label disabled={this.props.accountDailyFleetReportAvailabilityPending}>{accountDailyFleetReportAvailabilityEnabled?
                                strings.settings_feature_enabled
                            :
                                strings.settings_feature_disabled
                            }</label>
                            {this.props.accountDailyFleetReportAvailabilityPending ? <ProgressOverlay /> : null }
                        </div>
                        <div className="error-message">
                            {this.props.accountDailyFleetReportAvailabilityErrorMessage}
                        </div>
                    </div>
                    <div className='subgroup'>
                        <div className="description daily-reports">
                            {accountDailyFleetReportTimezone ?
                                strings.formatString(strings.settings_global_daily_reports_timezone_description, accountDailyFleetReportTimezone) + " "
                            :
                                null
                            }
                            {currentTimezone === configuredTimezone ?
                                strings.settings_global_daily_reports_timezone_is_the_same_as_current
                            :
                                <button onClick={() => {
                                    this.props.showConfirmationDialog(
                                        <ModalContainer title={strings.settings_global_daily_reports_change_time_zone_for_reported_times} smallDialogMode={true} >
                                            <div className="timezone-dialog">
                                                <div className="message">
                                                    {strings.formatString(strings.settings_global_daily_reports_timezone_your_browsers_current_time_zone_is_X, currentTimezone)}
                                                </div>
                                                <div className="actions">
                                                    <button className="destructive" onClick={this.props.dismissConfirmationDialog} >{strings.action_cancel}</button>
                                                    <button onClick={() => {
                                                        const oldTimezone = configuredTimezone;
                                                        this.applyAccountDailyFleetReportTimezoneTimeoutId = setTimeout(() => {this.props.timeoutAccountDailyFleetReportTimezone(oldTimezone)}, UPDATE_SETTINGS_TIMEOUT);
                                                        this.props.dismissConfirmationDialog();
                                                        this.props.applyAccountDailyFleetReportTimezone(currentTimezone, oldTimezone)
                                                        .then(
                                                            () => {clearTimeout(this.applyAccountDailyFleetReportTimezoneTimeoutId)},
                                                            () => {clearTimeout(this.applyAccountDailyFleetReportTimezoneTimeoutId)}
                                                        )
                                                    }} >{strings.formatString(strings.settings_global_daily_reports_action_apply_X_timezone, currentTimezone)}</button>
                                                </div>
                                            </div>
                                        </ModalContainer>
                                    );
                                }}>{strings.settings_global_daily_reports_action_auto_detect_timezone}</button>
                            }
                            {this.props.accountDailyFleetReportTimezonePending ? <ProgressOverlay /> : null }
                            {!accountDailyFleetReportAvailabilityEnabled ? <div className='disabled-overlay'></div> : null }
                        </div>
                        <div className="error-message">
                            {this.props.accountDailyFleetReportTimezoneErrorMessage}
                        </div>
                    </div>
                    <div className='subgroup daily-reports'>
                        <h5 className="subgroup-header daily-reports">
                            {strings.settings_global_daily_reports_email_header}
                            {accountDailyFleetReportEmails ? 
                                " (" + accountDailyFleetReportEmails.length + ") "
                            :
                                null
                            }
                            {this.props.accountDailyFleetReportEmailsPending ?
                                null
                            :
                                <>
                                {!accountDailyFleetReportEmails || accountDailyFleetReportEmails.length < DAILY_REPORTS_MAX_RECIPIENTS ?
                                    <button onClick={() => {
                                        this.props.showConfirmationDialog(
                                            <ModalContainer title={strings.settings_global_daily_reports_action_add_recipient_email} smallDialogMode={true} >
                                                <DailyReportsAddOrEditEmail
                                                    accountDailyFleetReportEmails = {accountDailyFleetReportEmails}
                                                    applyAccountDailyFleetReportEmail = {(newEmail) => {
                                                        const oldEmailsArray = accountDailyFleetReportEmails;
                                                        let newEmailsArray = [...accountDailyFleetReportEmails];
                                                        if (!newEmailsArray.includes(newEmail)) {
                                                            newEmailsArray.push(newEmail); // quietly correct the issues (form validation should have caught this already)
                                                        }
                                                        this.applyAccountDailyFleetReportEmailsTimeoutId = setTimeout(() => {this.props.timeoutAccountDailyFleetReportEmails(oldEmailsArray)}, UPDATE_SETTINGS_TIMEOUT);
                                                        this.props.dismissConfirmationDialog();
                                                        this.props.applyAccountDailyFleetReportEmails(newEmailsArray)
                                                        .then(
                                                            () => {clearTimeout(this.applyAccountDailyFleetReportEmailsTimeoutId)},
                                                            () => {clearTimeout(this.applyAccountDailyFleetReportEmailsTimeoutId)}
                                                        )
                                                    }}
                                                    dismissConfirmationDialog = {this.props.dismissConfirmationDialog}
                                                />
                                            </ModalContainer>
                                        );
                                    }}><span className="material-icons">add_circle</span></button>
                                :
                                    null
                                }
                                </>
                            }
                        </h5>
                        <div className="error-message">
                            {this.props.accountDailyFleetReportEmailsErrorMessage}
                        </div>
                        <div className="form email-recipients">
                            {accountDailyFleetReportEmails ?
                                accountDailyFleetReportEmails.map( (email, index) => {
                                    return (
                                        <div key={index}>
                                            {accountDailyFleetReportEmails.length > 1?
                                                <>
                                                <button onClick={() => {
                                                    this.props.showConfirmationDialog(
                                                        <ModalContainer title={strings.settings_global_daily_reports_action_remove_recipient_email} smallDialogMode={true} onClickClose={this.props.dismissConfirmationDialog}>
                                                            <div className="message">
                                                                <p>{strings.formatString(strings.settings_global_daily_reports_action_confirm_remove_X_email, email)}</p>
                                                            </div>
                                                            <div className="actions">
                                                                <button className="destructive" onClick={this.props.dismissConfirmationDialog} >{strings.action_cancel}</button>
                                                                <button onClick={() => {
                                                                    const oldEmailsArray = accountDailyFleetReportEmails;
                                                                    let newEmailsArray = accountDailyFleetReportEmails;
                                                                    const indexToRemove = newEmailsArray.indexOf(email);
                                                                    if (indexToRemove > -1) {
                                                                        newEmailsArray.splice(indexToRemove, 1);
                                                                    }                                                                    
                                                                    this.applyAccountDailyFleetReportEmailsTimeoutId = setTimeout(() => {this.props.timeoutAccountDailyFleetReportEmails(oldEmailsArray)}, UPDATE_SETTINGS_TIMEOUT);
                                                                    this.props.dismissConfirmationDialog();
                                                                    this.props.applyAccountDailyFleetReportEmails(newEmailsArray)
                                                                    .then(
                                                                        () => {clearTimeout(this.applyAccountDailyFleetReportEmailsTimeoutId)},
                                                                        () => {clearTimeout(this.applyAccountDailyFleetReportEmailsTimeoutId)}
                                                                    )
                                                                }} >{strings.settings_global_daily_reports_remove_email}</button>
                                                            </div>
                                                        </ModalContainer>
                                                    )
                                                }}><span className="material-icons red">remove_circle</span>
                                                </button>
                                                &nbsp;
                                                {email}
                                                </>
                                            :
                                                <>
                                                {email}
                                                &nbsp;
                                                <button onClick={() => {
                                                    this.props.showConfirmationDialog(
                                                        <ModalContainer title={strings.settings_global_daily_reports_action_replace_recipient_email} smallDialogMode={true} >
                                                            <DailyReportsAddOrEditEmail
                                                                accountDailyFleetReportEmailToReplace = {email}
                                                                accountDailyFleetReportEmails = {accountDailyFleetReportEmails}
                                                                applyAccountDailyFleetReportEmail = {(newEmail) => {
                                                                    const oldEmailsArray = accountDailyFleetReportEmails;
                                                                    let newEmailsArray = accountDailyFleetReportEmails;
                                                                    const indexToRemove = newEmailsArray.indexOf(email);
                                                                    if (indexToRemove > -1) {
                                                                        newEmailsArray.splice(indexToRemove, 1);
                                                                    }
                                                                    if (!newEmailsArray.includes(newEmail)) {
                                                                        newEmailsArray.push(newEmail); // quietly correct the issues (form validation should have caught this already)
                                                                    }
                                                                    this.applyAccountDailyFleetReportEmailsTimeoutId = setTimeout(() => {this.props.timeoutAccountDailyFleetReportEmails(oldEmailsArray)}, UPDATE_SETTINGS_TIMEOUT);
                                                                    this.props.dismissConfirmationDialog();
                                                                    this.props.applyAccountDailyFleetReportEmails(newEmailsArray)
                                                                    .then(
                                                                        () => {clearTimeout(this.applyAccountDailyFleetReportEmailsTimeoutId)},
                                                                        () => {clearTimeout(this.applyAccountDailyFleetReportEmailsTimeoutId)}
                                                                    )
                                                                }}
                                                                dismissConfirmationDialog = {this.props.dismissConfirmationDialog}
                                                            />
                                                        </ModalContainer>
                                                    )
                                                }}><span className="material-icons">edit</span>
                                                </button>
                                                </>
                                            }
                                        </div>        
                                    )
                                })
                            :
                                null
                            } 
                        </div>
                        {this.props.accountDailyFleetReportEmailsPending ? <ProgressOverlay /> : null }
                        {!accountDailyFleetReportAvailabilityEnabled ? <div className='disabled-overlay'></div> : null }
                    </div>
                </div>

            </div>
        );
    }
}

class DailyReportsAddOrEditEmail extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            email: "",
            emailValidationError: null
        }
    }

    static propTypes = {
        accountDailyFleetReportEmailToReplace: PropTypes.string, // populate to engage edit mode language
        accountDailyFleetReportEmails: PropTypes.array,
        applyAccountDailyFleetReportEmail: PropTypes.func.isRequired,
        dismissConfirmationDialog: PropTypes.func.isRequired
    }

    // copied from raven-support-webapp/src/components/pages/orders/OrderForm.js
    emailInvalidErrorMessage = (email) => { // returns reason string
        // TODO these validations are missing regex for valid characters
        if (email.length < 3) { // x@y
            return strings.settings_global_invalid_email_email_is_too_short;
        }
        const components = email.split("@");
        if (components.length !== 2) { // x@y
            return strings.settings_global_invalid_email_email_is_invalid;
        }
        if (components[0].length < 1) { // x is empty
            return strings.settings_global_invalid_email_email_is_invalid;
        }
        // validate email prefix valid characters/combos here (components[0])
        if (components[1].length < 3) { // domain name is too short
            return strings.settings_global_invalid_email_email_domain_is_too_short;
        }
        // validate email domain characters here (components[1])
        const domainComponents = components[1].split(".");
        if (domainComponents.length < 2) {
            return strings.settings_global_invalid_email_email_domain_is_invalid; // root domain
        }
        if (domainComponents[0].length === 0) {
            return strings.settings_global_invalid_email_email_domain_name_is_invalid;
        }
        if (domainComponents[1].length < 2 ) {
            return strings.settings_global_invalid_email_email_top_level_domain_name_is_invalid;
        }

        const matchingEmailIndex = this.props.accountDailyFleetReportEmails.indexOf(email);
        if (matchingEmailIndex !== -1) {
            return strings.settings_global_invalid_email_this_email_is_already_a_recipient;
        }
        return null;
    }

    onInputChange = (event) => {
        this.setState({
            email : event.target.value,
            emailValidationError: null
        });
    }

    onSubmit = (event) => {
        const emailValidationError = this.emailInvalidErrorMessage(this.state.email);
        if (emailValidationError) {
            this.setState({emailValidationError : emailValidationError});
            return;
        }
        this.props.applyAccountDailyFleetReportEmail(this.state.email);
    }

    render() {
        let disableSubmitButton = true;
        if (this.state.email && this.state.email.length > 0) {
            disableSubmitButton = false;
        }
        return (
            <div className="settings-default-modal">
                <div className="message">
                    {this.props.accountDailyFleetReportEmailToReplace? 
                        <p>{strings.settings_global_daily_reports_type_a_new_email_below}</p>
                    :
                        null
                    }
                    <input autoComplete="new-password" type="text" value={this.state.email} placeholder={strings.settings_global_daily_reports_type_email_address} onChange={this.onInputChange} />
                </div>
                <div className="error-message">
                    {this.state.emailValidationError}
                </div>
                <div className="actions">
                    <button className="destructive" onClick={this.props.dismissConfirmationDialog} >{strings.action_cancel}</button>
                    {this.props.accountDailyFleetReportEmailToReplace?
                        <button onClick={this.onSubmit} disabled={disableSubmitButton} >{strings.settings_global_daily_reports_replace_email}</button>
                    :
                        <button onClick={this.onSubmit} disabled={disableSubmitButton} >{strings.settings_global_daily_reports_add_email}</button>
                    }
                </div>
            </div>
        );
    }
}